import script from "./VideoDiagnostic.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoDiagnostic.vue?vue&type=script&setup=true&lang=ts"

import "./VideoDiagnostic.vue?vue&type=style&index=0&id=4f9a5998&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f9a5998"]])

export default __exports__